module.exports = __webpack_public_path__ + "img/tovim_hashnaim_yes.ee8c3fa0.png";